import type { ItemType, CraftingRecipe } from './types'

export const RECIPES: Record<string, CraftingRecipe> = {
  flour:           { inputs: [['wheat', 3]], outputs: [['flour', 2]] },
  bread:           { inputs: [['flour', 2], ['charcoal', 1]], outputs: [['bread', 3]] },
  ale:             { inputs: [['wheat', 4], ['barrels', 1]], outputs: [['ale', 3]] },
  wool:            { inputs: [['sheep', 1]], outputs: [['wool', 3]] },
  mutton:          { inputs: [['sheep', 1]], outputs: [['mutton', 2]] },
  leather:         { inputs: [['sheep', 1]], outputs: [['leather', 1]] },
  cloth:           { inputs: [['wool', 4]], outputs: [['cloth', 2]] },
  sails:           { inputs: [['cloth', 3], ['nails', 2]], outputs: [['sails', 1]] },
  eggs:            { inputs: [['chicken', 1]], outputs: [['eggs', 4]] },
  feathers:        { inputs: [['chicken', 1]], outputs: [['feathers', 3]] },
  poultry:         { inputs: [['chicken', 1]], outputs: [['poultry', 2]] },
  arrows:          { inputs: [['feathers', 2], ['wood', 1], ['iron', 1]], outputs: [['arrows', 6]] },
  bronze_tools:    { inputs: [['bronze', 2], ['wood', 1]], outputs: [['bronze_tools', 1]] },
  bronze_fittings: { inputs: [['bronze', 3]], outputs: [['bronze_fittings', 2]] },
  ship_hardware:   { inputs: [['bronze_fittings', 2], ['iron', 2]], outputs: [['ship_hardware', 1]] },
  iron_tools:      { inputs: [['iron', 2], ['wood', 1]], outputs: [['iron_tools', 1]] },
  nails:           { inputs: [['iron', 1]], outputs: [['nails', 8]] },
  weapons:         { inputs: [['iron', 3], ['wood', 1], ['leather', 1]], outputs: [['weapons', 1]] },
  chains:          { inputs: [['iron', 2]], outputs: [['chains', 1]] },
  armor:           { inputs: [['leather', 3], ['iron', 2]], outputs: [['armor', 1]] },
  ship_repair_kit: { inputs: [['nails', 4], ['planks', 2]], outputs: [['ship_repair_kit', 1]] },
  jewelry:         { inputs: [['gold', 1]], outputs: [['jewelry', 2]] },
  gilded_decor:    { inputs: [['gold', 1], ['wood', 1]], outputs: [['gilded_decor', 1]] },
  planks:          { inputs: [['wood', 2]], outputs: [['planks', 3]] },
  charcoal:        { inputs: [['wood', 3]], outputs: [['charcoal', 2]] },
  barrels:         { inputs: [['planks', 3], ['nails', 2]], outputs: [['barrels', 1]] },
  ship_parts:      { inputs: [['planks', 4], ['iron', 2]], outputs: [['ship_parts', 1]] },
  wine:            { inputs: [['fruit', 3], ['barrels', 1]], outputs: [['wine', 2]] },
  preserves:       { inputs: [['fruit', 2]], outputs: [['preserves', 3]] },
  dried_fruit:     { inputs: [['fruit', 3]], outputs: [['dried_fruit', 4]] },
}

// Smithy-only recipes (metal/weapon crafts)
export const SMITHY_RECIPES: ItemType[] = [
  'bronze_tools', 'bronze_fittings', 'iron_tools', 'nails',
  'weapons', 'chains', 'armor', 'ship_hardware', 'arrows', 'ship_repair_kit',
]

// Food/drink items available at the pub
export const PUB_ITEMS: ItemType[] = ['bread', 'ale', 'wine', 'mutton', 'poultry']

export function getRecipe(output: ItemType): CraftingRecipe | undefined {
  return RECIPES[output]
}
